// Sentry client (browser) initialization.
// Runs whenever a user loads a page in the browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/sign-in/:sign-in*?\",\"regex\":\"^/sign-in(?:/(.*))?$\",\"paramNames\":[\"sign-in\"],\"hasOptionalPrefix\":false},{\"path\":\"/agent_runs/:agent_run_id\",\"regex\":\"^/agent_runs/([^/]+)$\",\"paramNames\":[\"agent_run_id\"],\"hasOptionalPrefix\":false},{\"path\":\"/calls/:callId\",\"regex\":\"^/calls/([^/]+)$\",\"paramNames\":[\"callId\"],\"hasOptionalPrefix\":false},{\"path\":\"/companies/:companyId\",\"regex\":\"^/companies/([^/]+)$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/dlq/events/:eventType\",\"regex\":\"^/dlq/events/([^/]+)$\",\"paramNames\":[\"eventType\"],\"hasOptionalPrefix\":false},{\"path\":\"/dlq/messages/:id\",\"regex\":\"^/dlq/messages/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/dlq/queues/:queueName\",\"regex\":\"^/dlq/queues/([^/]+)$\",\"paramNames\":[\"queueName\"],\"hasOptionalPrefix\":false},{\"path\":\"/email-triage/:id\",\"regex\":\"^/email-triage/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/agent_runs\"},{\"path\":\"/analytics\"},{\"path\":\"/calls\"},{\"path\":\"/companies\"},{\"path\":\"/companies/new\"},{\"path\":\"/dlq\"},{\"path\":\"/dlq/events\"},{\"path\":\"/email-triage\"},{\"path\":\"/sso-callback\"},{\"path\":\"/unauthorized\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import { beforeSend } from "@/lib/sentry";

const SERVICE_NAME = "internal-dashboard";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const environment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? "local";
const release =
  process.env.NEXT_PUBLIC_SENTRY_RELEASE ??
  (process.env.VERCEL_GIT_COMMIT_SHA
    ? `${SERVICE_NAME}@${process.env.VERCEL_GIT_COMMIT_SHA}`
    : "local");
const tracesSampleRate = Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? "0");

Sentry.init({
  dsn,
  environment,
  release,
  tracesSampleRate,
  sendDefaultPii: false,
  beforeSend,

  // Session Replay intentionally disabled in this rollout.
  // See plan: sarahai-scratchpad/ai-notes/features/1-sentry-implementation/2-plan.md §Phase 1.
  // Re-enabling requires a written privacy review, masking config
  // (maskAllText/maskAllInputs/blockAllMedia), and CSS block selectors
  // for known PII surfaces (debtor pages, contact forms, payment screens).
  integrations: [],

  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "Network request failed",
    "Failed to fetch",
    /^AbortError/,
    /ChunkLoadError/,
  ],

  denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-extension:\/\//],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
